import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { SearchResultsDataObject } from 'models/service';

type GlobalSearchRequestParams = { query?: string };

export const getGlobalSearch = async ({ config: { params } }: ConfigRequest<GlobalSearchRequestParams>) =>
  apiClient.get<SearchResultsDataObject, ApiClientResponse<SearchResultsDataObject>>(routes.globalSearch.find, {
    params,
  });
